import {Component, ViewChild} from '@angular/core';
import {
    IonicPage,
    NavController,
    NavParams,
    VirtualScroll,
    AlertController,
    ActionSheetController,
    ModalController
} from 'ionic-angular';
import {InfiniteScrollComponent} from '../../components/inifiniteScrollComponent';
import {HomogenizationOrderApi} from '../../sdk';
import {LoadingComponent} from '../../components/loadingComponent';
import {IHomogenizationOrder} from "../../models/IHomogenizationOrder";

@IonicPage({
    segment: 'homogenization-order-list',
    name: 'HomogenizationOrderListPage'
})
@Component({
    selector: 'page-homogenization-order-list',
    templateUrl: 'homogenization-order-list.html',
})
export class HomogenizationOrderListPage extends InfiniteScrollComponent {

    @ViewChild(VirtualScroll) scroll: VirtualScroll;

    constructor(
        public modalCtrl: ModalController,
        public navCtrl: NavController,
        public alertCtrl: AlertController,
        public actionSheetCtrl: ActionSheetController,
        public params: NavParams,
        public homogenizationOrderService: HomogenizationOrderApi,
        public loading: LoadingComponent,
    ) {
        super(homogenizationOrderService);

        this.filterFields = IHomogenizationOrder.FIELDS;
        this.filterInclude = IHomogenizationOrder.FILTER_INCLUDE;
        this.filterLimit = 10;
        this.strFilterBar = IHomogenizationOrder.FILTER_DEFAULT;
        this.setFilterBar();
    }

    /**
     * Al cargar la pagina
     */
    ionViewDidLoad() {
        super.ionViewDidLoad();
        /*if(!(this.userRoles && (this.userRoles.isTurnChief() || this.userRoles.isHomogenizationUser()))){
            this.navCtrl.setRoot('FaqPage');
        }*/
    }

    /**
     * Function abstracta que devuelve el LoadingComponent
     */
    public getLoadingComponent(): LoadingComponent {
        return this.loading;
    }

    /**
     * Editar/Ver un homogenization.order
     * @param item
     */
    public homogenizationEdit(item: IHomogenizationOrder) {
        let modal = this.modalCtrl.create('HomogenizationOrderAddPage', {edit: item}, {cssClass: "full-popover"});
        modal.present();
        modal.onWillDismiss(data => {
            this.selectItem(item);
            if (data) {
                super.doRefresh(null);
            }
        });
    }

    public addInline(item: IHomogenizationOrder) {
        let modal = this.modalCtrl.create('HomogenizationOrderInlineAddPage', {order: item}, {cssClass: "full-popover"});
        modal.present();
        modal.onWillDismiss(data => {
            this.selectItem(item);
            if (data) {
                super.doRefresh(null);
            }
        });
    }

    public addOutline(item: IHomogenizationOrder) {
        let modal = this.modalCtrl.create('HomogenizationOrderOutlineAddPage', {order: item}, {cssClass: "full-popover"});
        modal.present();
        modal.onWillDismiss(data => {
            this.selectItem(item);
            if (data) {
                super.doRefresh(null);
            }
        });
    }

    /**
     * Marca este item como seleccionado, y deselecciona el resto
     * @param item
     */
    private selectItem(item: IHomogenizationOrder) {
        for (let i = 0; i < this.listItems.length; i++) {
            const element = this.listItems[i];
            element.isSelected = false;
        }
        item.isSelected = true;
    }

    public addHomogenizationOrder() {
        let modal = this.modalCtrl.create('HomogenizationOrderAddPage', {}, {cssClass: "full-popover"});
        modal.present();
        modal.onWillDismiss(data => {
            if (data) {
                //actualizar scroll
                super.doRefresh(null);
            }
        });

    }
}



// WEBPACK FOOTER //
// ./src/pages/homogenization-order-list/homogenization-order-list.ts